import React from 'react';
import { Container, Row, Col } from '@bootstrap-styled/v4';
import styled from 'styled-components';
import { MdClose } from 'react-icons/md';

import colors from 'shared-components/theme/colors';
import Media from 'shared-components/theme/medias';
import { gilroyMedium } from 'shared-components/theme/fonts';
import { baseURL } from 'shared-components/theme/helpers';

const BuildYourCXHeader = ({ headerMenus, closeForm, hideHeaderData }) => {
    return (
        <Wrapper>
            <Container fluid={true}>
                <Row>
                    <Col lg="2" xs="8">
                        <Logo>
                            {/* <img
                                src={`${baseURL}assets/images/ibex-logo.svg`}
                                alt="ibex logo red"
                            /> */}
                             <svg
                                    version="1.1"
                                    id="Layer_1"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlnsXlink="http://www.w3.org/1999/xlink"
                                    x="0px"
                                    y="0px"
                                    viewBox="0 0 79 37"
                                    style={{ enableBackground: "new 0 0 79 37" }}
                                    xmlSpace="preserve"
                                    width="64"
                                    height="30"
                                >
                                    <style type="text/css">
                                    {`
                                        .st0 { fill: #FA0060; }
                                    `}
                                    </style>
                                    <g>
                                    <g>
                                        <path
                                        className="st0"
                                        d="M0.8,8.1c0-2,1.6-3.6,3.7-3.6S8,6,8,8.1c0,2.1-1.6,3.7-3.6,3.7C2.3,11.7,0.8,10.2,0.8,8.1z M1.3,32.3V12.5 h6.3v19.8L1.3,32.3L1.3,32.3z"
                                        />
                                    </g>
                                    <g>
                                        <path
                                        className="st0"
                                        d="M31,21.9c0,6-4.2,10.4-9.8,10.4c-2.5,0-4.3-1-5.6-2.3v2.3H9.6V4.5h6.3v9.1c1.3-1.2,3-2,5.3-2 C26.8,11.6,31,15.9,31,21.9z M24.6,21.9c0-2.5-1.9-4.6-4.5-4.6c-2.6,0-4.5,2.1-4.5,4.6c0,2.6,1.9,4.6,4.5,4.6 C22.7,26.5,24.6,24.5,24.6,21.9z"
                                        />
                                    </g>
                                    <g>
                                        <path
                                        className="st0"
                                        d="M52.1,23.9H37.9c0.6,1.9,2.2,3.1,4.9,3.1c2.1,0,4.5-0.8,6-1.8l2.5,4.3c-2,1.4-5,2.7-8.8,2.7 c-7.4,0-11-4.9-11-10.4c0-5.9,4.2-10.4,10.6-10.4c5.7,0,10.2,3.6,10.2,9.9C52.3,22.2,52.2,23.1,52.1,23.9z M37.9,19.6h8.4 c-0.5-1.9-2-3.1-4.1-3.1C40.1,16.5,38.5,17.6,37.9,19.6z"
                                        />
                                    </g>
                                    <g>
                                        <path
                                        className="st0"
                                        d="M64.3,32.3l-3.2-6.1l-3.4,6.1h-7.6l6.5-10.5L51,11.5h7.6l2.7,5.6l3.2-5.6h7.3l-6.1,10.3l6.3,10.4L64.3,32.3 L64.3,32.3z"
                                        />
                                    </g>
                                    <circle className="st0" cx="74.8" cy="29.1" r="3.4" />
                                    </g>
                                </svg>
                        </Logo>
                    </Col>
                    <Col lg="9" xs="2">
                        {!hideHeaderData && (
                            <Menu>
                                {headerMenus &&
                                    headerMenus.length > 0 &&
                                    headerMenus.map((data, index) =>
                                        data.step === 'language' ||
                                        data.step === 'region' ||
                                        data.step === 'contact-center-type' ? (
                                            data.value &&
                                            data.value.length > 0 && (
                                                <MenuItem key={index}>
                                                    <a>
                                                        <span>
                                                            {data.value[0] &&
                                                            data.step !==
                                                                'language'
                                                                ? data.value[0]
                                                                : data.value[0]
                                                                      .label}
                                                        </span>
                                                        {data.value &&
                                                            data.value.length >
                                                                1 && (
                                                                <span>
                                                                    , +
                                                                    {data.value
                                                                        .length -
                                                                        1}
                                                                    more
                                                                </span>
                                                            )}
                                                    </a>
                                                </MenuItem>
                                            )
                                        ) : data.value ? (
                                            <MenuItem key={index}>
                                                <a>
                                                    {data.value && data.value}
                                                </a>
                                            </MenuItem>
                                        ) : (
                                            data.info &&
                                            (data.info.first_name !== '' ||
                                                data.info.last_name !== '' ||
                                                data.info.email !== '' ||
                                                data.info.phone_number !== '' ||
                                                data.info.organization !==
                                                    '') && (
                                                <MenuItem key={index}>
                                                    <a>
                                                        {data.info
                                                            .first_name !==
                                                            '' && (
                                                            <span>
                                                                {
                                                                    data.info
                                                                        .first_name
                                                                }
                                                                <span>
                                                                    &nbsp;
                                                                </span>
                                                            </span>
                                                        )}
                                                        {data.info.last_name !==
                                                            '' && (
                                                            <span>
                                                                {
                                                                    data.info
                                                                        .last_name
                                                                }
                                                            </span>
                                                        )}
                                                    </a>
                                                </MenuItem>
                                            )
                                        )
                                    )}
                            </Menu>
                        )}
                    </Col>
                    <Col lg="1" xs="2">
                        <CloseSliderIcon onClick={() => closeForm()}>
                            <MdClose />
                        </CloseSliderIcon>
                    </Col>
                </Row>
            </Container>
        </Wrapper>
    );
};
const Wrapper = styled.header`
    padding: 0px 60px;
    width: 100%;
    background-color: ${colors.gray_lighter['100']};
    z-index: 999;
    border-bottom: 1px solid ${colors.gray_dark['10']};
    height: 82px;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    ${Media('xlscreens')} {
        height: 5.3vw;
        padding: 0px 5vw;
    }
    ${Media('desktopscreens')} {
        height: 5.8vw;
        padding: 0px 5vw;
    }
    ${Media('tablet')} {
        padding: 0px 10px;
    }
`;
const CloseSliderIcon = styled.div`
    font-size: 30px;
    color: ${colors.gray_dark['50']};
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    height: 100%;
    ${Media('xlscreens')} {
        font-size: 1.57vw;
    }
`;
const Logo = styled.a`
    position: relative;
    display: flex;
    align-items: center;
    height: 100%;
    z-index: 1000;
    img {
        width: auto;
        height: 30px;
    }
    ${Media('xlscreens')} {
        padding-left: 3vw;
    }
    ${Media('mobile')} {
        img {
            height: 22px;
        }
    }
`;
const Menu = styled.div`
    margin-bottom: 0;
    display: flex;
    ${Media('tabletlandscape')} {
        padding: 0;
        width: 100%;
        margin-top: 50px;
        display: none;
    }
`;
const MenuItem = styled.div`
    display: flex;
    padding: 10px;
    height: 82px;
    position: relative;
    width: 110px;
    word-break: break-word;
    text-overflow: ellipsis;
    &:after {
        content: '';
        position: absolute;
        width: 100%;
        height: 2px;
        background-color: ${colors.pink['100']};
        left: 0px;
        bottom: 0px;
        transition: all 0.5s ease;
    }
    a {
        display: block;
        align-items: center;
        padding: 0 0px;
        position: relative;
        color: ${colors.gray_dark['100']};
        font-family: ${gilroyMedium};
        font-size: 12px;
        sup {
            top: -5px;
        }
    }
    ${Media('xlscreens')} {
        height: 5.3vw;
        padding-left: 0.5vw;
        padding-right: 0.5vw;
        margin: 0px 1vw;
        width: 5.78vw;
        padding-top: 2vw;
        a {
            font-size: 0.6vw;
            sup {
                font-size: 0.5vw;
            }
        }
    }
    ${Media('desktopscreens')} {
        &:after {
            bottom: -1.1vw;
            height: 3px;
        }
        a {
            font-size: 1.1vw;
        }
    }
`;

export default BuildYourCXHeader;
